class FaqSection {
  constructor(container) {
    this.container = container;
    this.navLinks = container.querySelectorAll('[data-faq-nav]');
    this.categories = container.querySelectorAll('[data-faq-category]');

    if (!this.navLinks.length || !this.categories.length) return;

    this.navLinks.forEach((link) => {
      link.addEventListener('click', (event) => this.onNavClick(event, link));
    });

    this.observer = new IntersectionObserver(
      (entries) => this.onCategoryIntersect(entries),
      {
        root: null,
        rootMargin: '-20% 0px -60% 0px',
        threshold: 0,
      }
    );

    this.categories.forEach((category) => this.observer.observe(category));
    this.setActiveNav(this.navLinks[0]?.dataset.faqNav);
  }

  onNavClick(event, link) {
    event.preventDefault();
    const targetId = link.getAttribute('href')?.slice(1);
    const target = targetId ? document.getElementById(targetId) : null;

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.setActiveNav(link.dataset.faqNav);
    }
  }

  onCategoryIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.setActiveNav(entry.target.dataset.faqCategory);
      }
    });
  }

  setActiveNav(activeId) {
    if (!activeId) return;

    this.navLinks.forEach((link) => {
      link.classList.toggle('is-active', link.dataset.faqNav === activeId);
    });
  }
}

document.querySelectorAll('[data-faq-section]').forEach((section) => {
  new FaqSection(section);
});
